<template>
  <div>
    <div class="tw-mt-3"><back-nav :to="$route.name === 'InstalmentPayment' ? 'Instalments' :  'PaymentSelection'" /></div>

    <v-card class="mx-auto tw-px-2 md:tw-px-4 tw-py-2 md:tw-py-4">
      <p class="c-blue-text tw-font-bold tw-px-0 md:tw-px-10">{{ data.quoteInfo.payPercentage === 100 ? 'Full Payment' : 'Instalment Payment' }}</p>
      <div class="tw-w-full tw-flex">
        <div class="tw-w-full tw-flex tw-justify-center tw-items-center tw-my-5 md:tw-my-8 tw-flex-wrap">
          <div class="tw-flex tw-px-2 md:tw-px-10 tw-border-r-0 md:tw-border-r-2 tw-border-gray-400">
            <img src="/images/icons/car-g.png" class="tw-h-16 lg:tw-h-auto tw-mr-2 lg:tw-mr-4" alt="car icon">
            <h3 class="c-gray-text c-title tw-text-base md:tw-text-xl tw-px-2 md:tw-px-8"><span v-html="data.quoteInfo.pageTitle"></span></h3>
          </div>
          <template v-if="scanObject(data, 'quoteInfo.coverType') === 'Bima Bamba<br> Insurance Cover'">
            <div class="tw-flex tw-grid tw-grid-cols-1 tw-px-2 md:tw-px-10 tw-text-center lg:tw-text-left">
              <h4 class="c-blue-text tw-font-bold tw-text-sm">
                {{ formatDateToMonth(scanObject(data, 'quoteInfo.paymentSchedule.0.dueDate'))  }}
                Instalment
              </h4>
              <h3 class="c-light-blue-text title-font tw-text-4xl md:tw-text-5xl">
                Kshs. {{ scanObject(data, 'payment.payableAmount')  | formatNum }}
              </h3>
            </div>
          </template>
          <template v-else-if="scanObject(data, 'quoteInfo.coverType.productCode') === 702">
            <div class="tw-flex tw-grid tw-grid-cols-1 tw-px-2 md:tw-px-10 tw-text-center lg:tw-text-left">
              <h4 class="c-blue-text tw-font-bold tw-text-sm">1st Instalment</h4>
              <h3 class="c-light-blue-text title-font tw-text-4xl md:tw-text-5xl">Kshs. {{ payableAmountPremium | formatNum }}</h3>
              <h4 class="c-blue-text tw-font-bold tw-text-sm">
                Ksh. {{ payableAmountPremium | formatNum }} per month for the following 11 months
              </h4>
            </div>
          </template>
          <template v-else>
            <div class="tw-flex tw-grid tw-grid-cols-1 tw-px-2 md:tw-px-10 tw-text-center lg:tw-text-left">
              <h1 class="tw-w-full c-light-blue-text tw-font-bold tw-text-5xl md:tw-text-6xl">{{ data.quoteInfo.payPercentage }}%</h1>
              <p class="tw-w-full c-light-blue-text tw-text-sm md:tw-text-base">of the sum insured</p>
            </div>
            <div class="tw-px-0 md:tw-px-10 tw-mt-5 md:tw-mt-0 tw-border-l-0 md:tw-border-l-2 tw-border-gray-400">
              <h4 class="c-blue-text tw-font-bold tw-text-sm">{{ data.quoteInfo.payPercentage === 100 ? 'Total Annual' : 'Instalment' }} Premium</h4>
              <h3 class="c-light-blue-text title-font tw-text-4xl md:tw-text-5xl">Kshs. {{ data.payment.payableAmount | formatNum }}</h3>
            </div>
          </template>
        </div>
      </div>
    </v-card>

    <v-card class="tw-mt-5 md:tw-mt-16 tw-pb-10">
      <div class="tw-px-4 md:tw-px-8">
        <card-title icon="mdi-cash">Choose your Mode of payment</card-title>
      </div>
      <div class="tw-flex tw-justify-center tw-px-4 md:tw-px-12 tw-mt-4 md:tw-mt-10">
        <div v-if="!paymentInitiated" class="tw-w-full md:tw-w-8/12">
          <v-tabs
              v-model="tab"
              centered
              icons-and-text
          >

            <v-tab v-if="stkSupported" href="#tab-1" :class="['tw-px-2 payment-tab', currentTab === 'stk' ? 'payment-tab-active' : '']" @click="currentTab = 'stk'">
              <img :src="[currentTab === 'stk' ? '/images/payment/mpesa-b.png' : '/images/payment/mpesa.png']" width="120" alt="mpesa">
            </v-tab>

            <v-tab v-if="paybillSupported" href="#tab-2" :class="['tw-px-2 payment-tab', currentTab === 'paybil' ? 'payment-tab-active' : '']" @click="currentTab = 'paybil'">
              <img :src="[currentTab === 'paybil' ? '/images/payment/paybill-b.png' : '/images/payment/paybil.png']" width="120" alt="mpesa">
            </v-tab>

            <v-tab v-if="cardSupported" href="#tab-3" :class="['tw-px-2 payment-tab', currentTab === 'card' ? 'payment-tab-active' : '']" @click="currentTab = 'card'">
              <img :src="[currentTab === 'card' ? '/images/payment/card-b.png' : '/images/payment/card.png']" width="120" alt="card">
            </v-tab>
          </v-tabs>

          <v-tabs-items v-model="tab">
            <v-tab-item value="tab-1">
              <v-card class="tw-flex tw-justify-center" flat>
               <div class="tw-w-full md:tw-w-8/12 tw-px-2 md:tw-px-8 tw-py-2 md:tw-py-8">
                 <p class="c-blue-text tw-text-center">Enter the Phone Number to pay from</p>
                 <v-form v-model="stkValid">
                   <v-text-field v-model="form.customerPhoneNumber" type="text" label="Phone Number" class="tw-w-full md:tw-w-8/12 offset-md-2 my-3 tw-mt-4" :rules="[required('Phone Number'), mobileFormat()]"></v-text-field>
                   <v-card-actions class="col-sm-4 offset-sm-4 tw-mt-5 tw-pb-8">
                     <v-btn block large
                            color="secondary"
                            class="my-3 "
                            :loading="loading"
                            :disabled="!stkValid"
                            @click="requestSTK"
                     >
                       Pay
                     </v-btn>
                   </v-card-actions>
                 </v-form>
               </div>
              </v-card>
            </v-tab-item>
            <v-tab-item value="tab-2">
              <v-card class="tw-flex tw-justify-center" flat>
                <div class="tw-w-full md:tw-w-8/12 tw-px-2 md:tw-px-8 tw-py-2 md:tw-py-8">
                  <p class="c-blue-text">From your phone;</p>
                  <ul class="tw-mt-4">
                    <li>Go to SIM Toolkit Menu/Mpesa App</li>
                    <li>Select Mpesa</li>
                    <li>Select Lipa Na Mpesa</li>
                    <li>Select Pay Bill</li>
                    <li>Enter Business No: <strong>511600</strong></li>
                    <li>Enter Account No: <strong>{{ data.payment.accountReference.replace(' ', '') }}</strong></li>
                    <li>Enter Amount: KSH. <strong>{{ data.payment.payableAmount | formatNum }}</strong></li>
                  </ul>
                  <p class="c-blue-text tw-mt-4">Enter the transaction code you received from MPESA</p>
                  <v-form v-model="isFilled">
                    <v-text-field id="mpesaRef" v-model="mpesaRef" :rules="[required('Mpesa Reference No')]" type="text" label="Transaction Code" class="tw-w-full md:tw-w-8/12 offset-md-2 my-3 tw-mt-4" v-uppercase></v-text-field>
                    <v-card-actions class="col-sm-6 offset-sm-3 tw-mt-5 tw-pb-8">
                      <v-btn block large
                             color="secondary"
                             class="my-3 "
                             :loading="paybillLoading"
                             @click="queryMpesaPaybill"
                             :disabled="!isFilled"
                      >
                        Confirm Payment
                      </v-btn>
                    </v-card-actions>
                  </v-form>
                </div>
              </v-card>
            </v-tab-item>
            <v-tab-item value="tab-3">
              <card-payment :data="data" />
            </v-tab-item>
          </v-tabs-items>
          <div class="tw-flex tw-justify-center">
            <div class="tw-w-full md:tw-w-8/12 tw-px-2 md:tw-px-8">
              <p class="c-blue-text tw-mt-4"><small>Note: The transaction name that will reflect in your statement is ‘APA Insurance’</small></p>
              <p class="c-gray-text tw-mt-4">For assistance: <span class="c-blue-text">0709912777</span></p>
            </div>
          </div>
        </div>
        <div v-else class="tw-w-full md:tw-w-8/12 tw-flex tw-justify-center tw-flex-col">
          <div>
            <div v-if="!notificationAllowed" class="tw-w-full tw-px-4 md:tw-px-8">
              <div class="tw-w-full md:tw-w-full tw-my-4 tw-flex tw-items-center tw-bg-blue-200 tw-text-center lg:tw-text-left tw-rounded-lg lg:tw-rounded-lg tw-border-blue-500 tw-px-2 md:tw-px-6 tw-py-3 tw-flex tw-justify-between" role="alert">
                <p>Allow Notifications to see receive important updates </p>
                <span class="tw-bg-blue-500 tw-px-4 tw-py-0 tw-rounded-lg lg:tw-rounded-lg tw-text-sm tw-cursor-pointer" @click="requestNotification">ALLOW</span>
              </div>
            </div>

            <div v-if="notificationDenied" class="tw-w-full tw-px-4 md:tw-px-8">
              <div class="tw-w-full md:tw-w-full tw-my-4 tw-flex tw-items-center tw-bg-orange-200 tw-rounded-lg lg:tw-rounded-lg tw-border-orange-500 tw-px-2 md:tw-px-6 tw-py-3 tw-flex tw-justify-between" role="alert">
                <p>Notifications BLOCKED! Allow Notifications to receive important updates, Go to site settings to allow </p>
              </div>
            </div>
          </div>
          <div v-if="paymentStatus === 'PENDING'" class="tw-flex tw-justify-center">
            <img class="tw-w-32 md:tw-w-40" src="/images/hourglass.gif" alt="loading">
          </div>
          <div class="tw-text-center">
            <h2 :class="[paymentStatus === 'FAILED' || paymentStatus === null ? 'tw-text-red-500' : 'tw-text-green-500' , 'tw-text-xl md:tw-text-3xl tw-mb-3']"> {{ paymentStatus === 'PENDING' ? 'Check your mobile for a payment request via MPESA' : paymentStatus === 'SUCCESSFUL' ? 'Payment Was Successful' : 'Payment Failed, Something went wrong!' }}</h2>
            <div v-if="paymentStatus === 'PENDING'">
              <p class="c-gray-text">Check your phone for MPESA payment request, <br> Enter your MPESA pin to complete the process
              </p>
              <p class="c-gray-text tw-mt-2">You will receive a notification on successful payment regarding your policy</p>
              <p class="c-gray-text tw-mt-2">This may take a few minutes</p>
              <p v-if="waiting" class="tw-mt-2 tw-text-blue-500">We're Almost there, Processing ....</p>
            </div>
          </div>
          <div v-if="!statusLoaded" class="tw-w-full lg:tw-w-3/4 tw-self-center tw-bg-orange-200 tw-rounded-lg tw-p-4 md:tw-mt-8 c-gray-text tw-mt-4">
            <p>In case you did not receive the payment request on your mobile phone, <br>
              Kindly dial *234*1*6# to allow you to receive the payment request when transacting. <br> Refresh Page to retry
            </p>
          </div>
          <div v-if="statusLoaded" class="tw-w-full lg:tw-w-3/4 tw-self-center">
            <div v-if="paymentStatus === 'SUCCESSFUL'" class="tw-bg-green-200 tw-rounded-lg tw-p-4 md:tw-mt-8 c-gray-text tw-mt-4">
              <p v-if="scanObject(data.payment, 'description', '').includes('ext-')">Your Payment was received successfully.</p>
              <p v-else><strong>Your Payment was received successfully.</strong> <br>
                Your policy is currently being processed. You will receive a certificate on email. Please print and stick it on your car windscreen. Thank you for choosing us as your preferred insurer. APA, Insuring Happiness</p>

              <div class="tw-mt-4 tw-mt-8 tw-px-4 tw-flex tw-justify-center">
                <v-btn
                    :to="{name: 'MyPolicies'}"
                    color="secondary"
                >View My Policies</v-btn>
              </div>
            </div>
            <div v-if="paymentStatus === 'FAILED'" class="tw-bg-red-200 tw-rounded-lg tw-p-4 md:tw-mt-8 c-gray-text tw-mt-4">
              <p>Your Payment was NOT successful <br>  You'll be required to retry paying</p>
            </div>
          </div>

          <div v-if="paymentRetry || paymentStatus === 'FAILED'" class="tw-mt-4 tw-mt-8 tw-px-4 tw-flex tw-justify-center">
            <v-btn
                color="secondary"
                @click="paymentInitiated = false"
            >Retry payment Request</v-btn>
          </div>
        </div>
      </div>
    </v-card>
  </div>
</template>

<script>
import CardTitle from '@/components/shared/CardTitle';
import BackNav from '@/components/buy/BackNav';
import axios from 'axios';
import {
  FB_BUY_PAYMENT_FAILURE,
  FB_BUY_PAYMENT_INIT,
  FB_BUY_PAYMENT_INIT_FAIL,
  FB_BUY_PAYMENT_PAYBILL,
  FB_BUY_PAYMENT_STK,
  FB_BUY_PAYMENT_SUCCESS,
} from '@/utils/const';
import CardPayment from '@/components/buy/CardPayment';
import { formatDateToMonth } from '@/utils/time';
import paymentMixin from '@/mixins/paymentMixin';

export default {
  name: 'MakePayment',
  props: ['data'],
  components: { CardPayment, BackNav, CardTitle },
  mixins: [paymentMixin],
  data() {
    return {
      tab: null,
      currentTab: 'stk',
      form: {},
      paybillSupported: true,
      cardSupported: true,
      stkSupported: true,
    };
  },
  metaInfo: {
    title: 'Make Payment',
  },
  mounted() {
    this.form = this.data.payment;
  },
  computed: {
    installments() {
      return this.scanObject(this.data, 'quoteInfo.coverType.riskPremDto.installments', []);
    },
    payableAmountPremium() {
      return this.data.payment.payableAmount;
    },
  },
  methods: {
    formatDateToMonth,
    requestSTK() {
      this.loading = true;
      this.waiting = false;
      this.paymentRetry = false;
      this.paymentStatus = 'PENDING';
      const data = { ...{ serviceType: 'MOTOR', transactionType: 'PAYMENT' }, ...this.$data.form };
      axios.post('/customer/payment-wallet/mpesa-express/payment-request', data)
        .then((response) => {
          if (response.data.success) {
            this.$analytics.logEvent(FB_BUY_PAYMENT_INIT);
            this.$toast.success('Request sent, check your phone to finish the process', 'Payment');
            this.paymentInitiated = true;
            this.timeoutId = setTimeout(() => {
              this.checkPaymentStatus(response.data.data.checkoutRequestId);
            }, 30000);
          } else {
            this.$analytics.logEvent(FB_BUY_PAYMENT_INIT_FAIL);
            this.$toast.error('An Error occurred, please try again !', 'Payment');
          }
          this.loading = false;
        });
    },
    checkPaymentStatus(id) {
      axios.get(`/customer/payment-wallet/mpesa-express/transaction-details?checkoutRequestId=${id}`)
        .then((resp) => {
          if (resp.data.success) {
            const status = resp.data.data.paymentStatus;
            this.paymentStatus = status;
            if (status === 'PENDING') {
              this.waiting = true;
              this.timeoutId = setTimeout(() => {
                this.checkPaymentStatus(resp.data.data.checkoutRequestId);
              }, 30000);
            }
            if (status === 'FAILED') {
              this.paymentInitiated = true;
              this.paymentRetry = true;
              this.$analytics.logEvent(FB_BUY_PAYMENT_FAILURE);
            }
            if (status === 'SUCCESSFUL') {
              this.$analytics.logEvent(FB_BUY_PAYMENT_STK);
              this.$analytics.logEvent(FB_BUY_PAYMENT_SUCCESS);
            }
            this.statusLoaded = true;
          }
        });
    },
    queryMpesaPaybill() {
      this.$analytics.logEvent(FB_BUY_PAYMENT_INIT);
      this.paybillLoading = true;
      axios.get(`/customer/payment-wallet/query-gis?mpesaRef=${this.mpesaRef}`)
        .then((resp) => {
          if (resp.data.success) {
            this.statusLoaded = true;
            this.paymentStatus = 'SUCCESSFUL';
            this.$toast.success(resp.data.msg, 'Payment');
            this.$analytics.logEvent(FB_BUY_PAYMENT_SUCCESS);
            this.$analytics.logEvent(FB_BUY_PAYMENT_PAYBILL);
          } else {
            this.$toast.error(resp.data.msg, 'Payment');
            this.$analytics.logEvent(FB_BUY_PAYMENT_FAILURE);
          }
          this.paybillLoading = false;
        });
    },
  },
};
</script>
<style>
.v-tabs-slider {
  background-color: #2196F3!important;
  height: 4px!important;
}

.payment-tab {
  border-radius: 8px;
  transition: all 0.3s ease;
  margin: 0 4px;
}

.payment-tab:hover {
  background-color: rgba(33, 150, 243, 0.08)!important;
}

.payment-tab-active {
  background-color: rgba(33, 150, 243, 0.12)!important;
  box-shadow: 0 2px 8px rgba(33, 150, 243, 0.3);
}
</style>
